<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header pb-0 mb-3">
          <div class="d-flex align-items-center">
            <h4 class="mb-0">Clientes</h4>
          </div>
        </div>
        <div class="row container-fluid">
          <div class="card-body px-0 pt-0 pb-2 ">
            <div class="table-responsive p-0 col-md-12">
              <table class="table table-hover" id="my-table-clientes">
                <thead>
                  <tr>
                    <th scope="col">Ordenar</th>
                  </tr>
                </thead>
                <tbody v-if="clientes.length !== 0">
                  <tr v-for="(cliente) in clientes" :key="cliente.id"
                    @click="cliente.sucursales.length > 1 ? abrirModalSucursales(cliente) : abrirModal(cliente)">
                    <td>{{ `${cliente.nombre}` }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import $ from 'jquery';
import 'datatables.net';

// interface Cliente {
//   codigoSAP: "CL00070"
//   direccion: "Blvd. Antonio Rocha Cordero km 7.6, Tierra Blanca, Gral I. Martinez"
//   email: "ecommerce@motoboutique.mx"
//   id: 26
//   nombre: "MOTO DEPOT"
// }

export default {
  name: "clients-table",
  props: {
    clientes: {
      type: Array,
      request: true,
    },
  },
  data() {
    return {
      sucursalSelected: undefined
    }
  },
  mounted() {
    this.clientes.map(obj => {
      obj.openMenu = false;
    })
    $('#my-table-clientes').DataTable({
      order: [[0, 'asc']],
      pageLength: 50,
      lengthChange: false,
      columnDefs: [{
        orderData: 0,
        type: 'string'
      },
      ],
      language: {
        url: '//cdn.datatables.net/plug-ins/2.1.2/i18n/es-MX.json'
      },
    });
  },
  methods: {
    abrirModal(cliente) {
      this.$swal.fire({
        title: `<strong>${cliente.nombre}</u></strong>`,
        icon: "info",
        html: `
    <div class="card card-profile">
    <div class="card-body pt-0">
      <div class="text-center mt-4">
        <h4>
          ${cliente.codigoSAP ? cliente.codigoSAP : ""}
        </h4>
        <div class="h5 font-weight-300">
          ${cliente.email ? cliente.email : ''}
        </div>
        <div class="h5 font-weight-300  mt-4">
          ${cliente.sucursales.length > 0 ?
            cliente.sucursales[0].id > 0 ?
              cliente.sucursales[0].nombre
              :
              ''
            :
            ''
          }
        </div >
        <div class="h6 mt-3 font-weight-300">
          ${cliente.sucursales.length > 0 ?
            cliente.sucursales[0].id > 0 ?
              cliente.sucursales[0].direccion
              :
              ''
            :
            ''
          }
        </div>
      </div>
    </div>
  </div>
  `,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: "Iniciar pedido",
        confirmButtonColor: 'bg-primary',
        cancelButtonText: "Regresar",
        focusConfirm: false,
        customClass: {
          confirmButton: 'btn btn-warning btn-block m-3 bg-primary',
          cancelButton: 'btn btn-warning btn-block m-3 bg-secondary'
        },
        buttonsStyling: false,  // Desactivar el estilo predeterminado
      }).then((result) => {
        if (result.isConfirmed) {
          let clientSucursalAux = btoa(0);
          let sucursalIdAux = btoa(0)
          if (cliente.sucursales.length > 0)
            if (cliente.sucursales[0].id > 0) {
              sucursalIdAux = btoa(cliente.sucursales[0].id)
              clientSucursalAux = btoa(cliente.sucursales[0].nombre.length > 0 ? cliente.sucursales[0].nombre : 0)
            }

          this.$router.push({ name: 'Scanner', params: { clientId: btoa(cliente.id), sucursalId: sucursalIdAux, clientName: btoa(cliente.nombre), clientSucursal: clientSucursalAux } })
        }
      })
    },
    abrirModalSucursales(cliente) {
      const options = {};

      cliente.sucursales.forEach((sucursal) => options[sucursal.id] = `${sucursal.nombre} ${sucursal.direccion}`)

      this.$swal.fire({
        title: `<strong>${cliente.nombre}</u></strong>`,
        icon: "info",
        html: `
    <div class="card card-profile">
    <div class="card-body pt-0">
      <div class="text-center mt-4">
        <h5>
          ${cliente.codigoSAP ? cliente.codigoSAP : ""}
        </h5>
        <div class="h6 font-weight-300">
          <i class="ni location_pin mr-2"></i>${cliente.email ? cliente.email : ''}
        </div>
      </div>
    </div>
  </div>
  `,
        showConfirmButton: true,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: "Iniciar pedido",
        cancelButtonText: "Regresar",
        focusConfirm: false,
        input: 'select',
        inputOptions: options,
        inputPlaceholder: 'Selecciona una sucursal',
        customClass: {
          confirmButton: 'btn btn-warning btn-block m-3 bg-primary',
          cancelButton: 'btn btn-warning btn-block m-3 bg-secondary'
        },
        buttonsStyling: false,  // Desactivar el estilo predeterminado
        inputValidator: (value) => {
          return new Promise((resolve) => {
            if (value) {
              this.sucursalSelected = cliente.sucursales.find((sucursal) => sucursal.id = value)
              resolve()
            } else {
              resolve('Es necesario seleccionar una sucursal')
            }
          })
        }
      }).then((result) => {
        if (result.isConfirmed) {
          this.$router.push({ name: 'Scanner', params: { clientId: btoa(cliente.id), sucursalId: btoa(this.sucursalSelected.id), clientName: btoa(cliente.nombre), clientSucursal: btoa(this.sucursalSelected.nombre) } })
        }
      })
    }
  }
};
</script>
